<template>
  <div>
    <v-card>
      <v-card-title>
        {{ $t("stockReconcileList") }}
        <v-spacer></v-spacer>
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('search')"
            single-line
            hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
          :loading="loading"
          :headers="headers"
          :items="stockReconcileList"
          :search="search"
          hide-default-footer
          class="elevation-1"
          :server-items-length="totalPage"
          :items-per-page="itemsPerPage"
          :page.sync="currentPage"
          :options.sync="options"
          :mobile-breakpoint="0"
      >
        <template v-slot:progress>
          <v-progress-circular
              indeterminate
              color="green"
              :value="50"
          ></v-progress-circular>
        </template>
        <template v-slot:header.date="{ header }">
          {{ $t(header.text) }}
        </template>
        <template v-slot:header.reference="{ header }">
          {{ $t(header.text) }}
        </template>
        <template v-slot:header.client_name="{ header }">
          {{ $t(header.text) }}
        </template>
        <template v-slot:header.note="{ header }">
          {{ $t(header.text) }}
        </template>

        <template v-slot:header.action="{ header }">
          {{ $t(header.text) }}
        </template>

        //Body
        <template v-slot:item.amount="{item}">
          {{item.amount | formatNumber}} {{getCurrencySymbol(item.currency_code)}}

        </template>

        //Action
        <template v-slot:item.action="{ item }">
          <v-btn color="success" outlined class="table-action-button" text icon
                          :to="{ name: 'beeshop.agri-input.reporting.stock-reconcile-detail', params: { stockReconcileDoc: item}}">
            <font-awesome-icon icon="eye"/>
          </v-btn>
        </template>
      </v-data-table>
      <div class="text-center pt-2">
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-col
              v-if="!$vuetify.breakpoint.xsOnly"
              class="d-flex"
              cols="12"
              sm="1"
          >
            {{ $t("total") }} : {{ totalPage }}
          </v-col>
          <v-col
              class="d-flex"
              cols="12"
              sm="1"
              v-if="!$vuetify.breakpoint.xsOnly"
          >
            <v-select
                :label="$t('perPage')"
                v-model="itemsPerPage"
                :items="pageList"
            ></v-select>
          </v-col>

          <v-pagination
              v-model="currentPage"
              :length="pageCount"
              circle
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              :total-visible="$vuetify.breakpoint.mobile ? 5 : 10"
          ></v-pagination>
          <v-col
              class="d-flex"
              cols="12"
              sm="1"
              v-if="!$vuetify.breakpoint.xsOnly"
          >

            <v-text-field
                v-model="currentPageComputed"
                :max="pageCount"
                min="1"
                type="number"
                :label="$t('goto')"
            ></v-text-field>
          </v-col>
        </v-card-actions>
      </div>
    </v-card>
  </div>
</template>
<script>
import MainMixin from "../../../mixins/mainMixin";
import ValidatorMixin from "../../../mixins/validatorMixin";
import OptionDataMixin from "../../../mixins/optionDataMixin";
import _ from "lodash";

export default {
  name: "bee_stock_reconcile_list",
  mixins: [MainMixin, ValidatorMixin, OptionDataMixin],
  data() {
    return {
      headers: [
        {
          text: "receivePaymentDate",
          align: "start",
          value: "date"
        },
        {text: "reference", value: "reference"},
        {text: "member", value: "client_name", sortable:false},
        {text: "note", value: "note" ,sortable: false},
        {text: "action", value: "action", sortable: false, width: 50}

      ],
    };
  },
  methods: {
    fetchDataTable: _.debounce(function () {
      let vm = this;
      vm.loading = true;
      vm.fetchStockReconcileList({
        search: vm.search,
        id: "",
        eco_business: 'in_side',
        offset: vm.currentPage,
        limit: vm.itemsPerPage,
        sortBy: vm.options.sortBy[0] || "created_at",
        sortDesc: vm.options.sortDesc[0]===false ? 0 : 1,
      })
    }, 350),
    submit() {
      let vm = this;
      vm.dialog = false;
    },
  },
  computed: {
    userDoc() {
      return this.$store.state.userDoc;
    }
  },
  watch: {
    search() {
      this.fetchDataTable();
    },
  },
  created() {

  }
};
</script>
